// const Loader = () => {
//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "100vh",
//         position: "fixed",
//         background: "rgba(255,255,255,0.7)",
//         top: "0",
//         left: "0",
//         right: "0",
//         bottom: "0",
//         textAlign: "center",
//         zIndex: 99999,
//       }}
//       className="pt-5"
//     >
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         style={{ margin: "auto", display: "block", shapeRendering: "auto" }}
//         width="200px"
//         height="200px"
//         viewBox="0 0 100 100"
//         preserveAspectRatio="xMidYMid"
//       >
//         <path
//           fill="none"
//           stroke="#e90c59"
//           stroke-width="8"
//           strokeDasharray="42.76482137044271 42.76482137044271"
//           d="M24.3 30C11.4 30 5 43.3 5 50s6.4 20 19.3 20c19.3 0 32.1-40 51.4-40 C88.6 30 95 43.3 95 50s-6.4 20-19.3 20C56.4 70 43.6 30 24.3 30z"
//           stroke-linecap="round"
//           style={{ transform: "scale(0.8)", transformOrigin: "50px 50px" }}
//         >
//           <animate
//             attributeName="stroke-dashoffset"
//             repeatCount="indefinite"
//             dur="1s"
//             keyTimes="0;1"
//             values="0;256.58892822265625"
//           ></animate>
//         </path>
//       </svg>
//     </div>
//   );
// };

// export default Loader;

const Loader = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        position: "fixed",
        background: "rgba(255,255,255,0.7)",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        textAlign: "center",
        zIndex: 99999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <svg
        fill="none"
        height="10%"
        width="10%"
        viewBox="0 0 29 29"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="i0">
          <g>
            <path
              d="M12.43,28.59C12.43,28.59,12.43,13.65,12.43,13.65C12.43,13.65,25.31,25.44,25.31,25.44"
              stroke-width="4.3"
              stroke="#de4533"
              stroke-opacity="0.2"
            />
            <path
              d="M28.59,2.15C28.59,2.15,2.15,2.15,2.15,2.15C2.15,2.15,2.15,28.59,2.15,28.59"
              stroke-width="4.3"
              stroke="#de4533"
              stroke-opacity="0.2"
            />
            <path
              stroke-dasharray="0 100"
              pathLength="100"
              d="M12.43,28.59C12.43,28.59,12.43,13.65,12.43,13.65C12.43,13.65,25.31,25.44,25.31,25.44"
              stroke-width="4.3"
              stroke="#de4533"
            >
              <animate
                repeatCount="indefinite"
                fill="freeze"
                begin="0s"
                dur="1.417s"
                calcMode="spline"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
                keyTimes="0; 0.130435; 0.26087; 0.391304; 0.513043; 0.782609; 1"
                values="0 100; 16.667 83.333; 33.333 66.667; 50 50; 65.556 34.444; 100 0; 100 0"
                attributeName="stroke-dasharray"
              />
              <animate
                repeatCount="indefinite"
                fill="freeze"
                begin="0s"
                dur="1.417s"
                calcMode="spline"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
                keyTimes="0; 0.130435; 0.26087; 0.391304; 0.513043; 0.782609; 1"
                values="0; 0; 0; 0; 0; 0; 0"
                attributeName="stroke-dashoffset"
              />
            </path>
            <path
              stroke-dasharray="0 100"
              pathLength="100"
              d="M28.59,2.15C28.59,2.15,2.15,2.15,2.15,2.15C2.15,2.15,2.15,28.59,2.15,28.59"
              stroke-width="4.3"
              stroke="#de4533"
            >
              <animate
                repeatCount="indefinite"
                fill="freeze"
                begin="0s"
                dur="1.417s"
                calcMode="spline"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
                keyTimes="0; 0.130435; 0.26087; 0.391304; 0.513043; 0.782609; 1"
                values="0 100; 16.667 83.333; 33.333 66.667; 50 50; 65.556 34.444; 100 0; 100 0"
                attributeName="stroke-dasharray"
              />
              <animate
                repeatCount="indefinite"
                fill="freeze"
                begin="0s"
                dur="1.917s"
                calcMode="spline"
                keySplines="0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1; 0 0 1 1"
                keyTimes="0; 0.130435; 0.26087; 0.391304; 0.513043; 0.782609; 1"
                values="0; 0; 0; 0; 0; 0; 0"
                attributeName="stroke-dashoffset"
              />
            </path>
          </g>
        </g>
      </svg>
    </div>
  );
};

export default Loader;
